import { StoreRemove02Icon } from '@hugeicons/react'

import { Button } from '@/shared/ui/Button'

import { StoreStatusPanel } from './StoreStatusPanel'

export const DigitalProductStoreAlertsAlreadyClosed = ({ refetchStore }) => {
  return (
    <StoreStatusPanel
      icon="shop"
      badge={
        <>
          <StoreRemove02Icon size={14} aria-hidden />
          Encerrada
        </>
      }
      title={
        <h2 className="m-0 text-xl font-extrabold leading-snug text-gray-900">
          A lojinha está fechada
        </h2>
      }
      description="As reservas não estão disponíveis no momento. Fique atento — a lojinha pode reabrir durante o evento."
      footer={
        <Button
          type="button"
          variant="primary"
          size="sm"
          showTrailingIcon={false}
          onClick={refetchStore}
        >
          Atualizar status
        </Button>
      }
    />
  )
}
